import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import transactionService from "../../../services/transaction.service";
import userWithdraw from "@/services/withdraw";

interface Init {
  loading: boolean;
  error: null | undefined | string;
  totalPrice: number;
  totalProfit: number;
  transactions: any[] | null;
  withdrawalRequests: any[] | null;
  userTransaction: any[] | null;
  userApprovedTransation: any[] | null;
}

export interface WithDrawInfo {
  amount: number;
  network: string;
  walletId: string;
}

const initialState: Init = {
  loading: false,
  error: null,
  totalPrice: 0,
  totalProfit: 0,
  transactions: null,
  withdrawalRequests: null,
  userTransaction: null,
  userApprovedTransation: null,
};

export const requestWithdraw = async ({ data }: { data: WithDrawInfo }) => {
  try {
    const response = await userWithdraw.requestWithdraw(data);
    return response.data;
  } catch (error: any) {
    return error?.response?.data.message;
  }
};

// export const approveWithdraw = createAsyncThunk(
//   "transaction/approveWithdraw",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await transactionService.approveWithdraw(id);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   }
// );

export const deleteWithdraw = async (id: string | number) => {
  try {
    const response = await transactionService.deleteWithdraw(id);
    return response.data?.message;
  } catch (error: any) {
    return error?.response?.data.message;
  }
};

export const fetchAllWithdrawn = createAsyncThunk(
  "transaction/fetchWithdrawn",
  async (_, { rejectWithValue }) => {
    try {
      const response = await transactionService.getAllTransactions();
      return response.data.transactions;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const fetchAllApproved = createAsyncThunk(
  "transaction/fetchApproved",
  async (_, { rejectWithValue }) => {
    try {
      const response = await transactionService.getAllApproved();
      return response.data.transactions;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const fetchAllWithDrawReqwuests = createAsyncThunk(
  "withDrawals/All",
  async (_, { rejectWithValue }) => {
    try {
      const response = await transactionService.getAllWithdrawalRequest();
      return response.data.transactions;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const fetchUserTransactions = createAsyncThunk(
  "transaction/userAllTransactions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await transactionService.getUserTransactions();
      return response.data.userTransactions;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchUserWithdrawnTransactions = createAsyncThunk(
  "transaction/withdrawn",
  async (_, { rejectWithValue }) => {
    try {
      const response = await transactionService.getUserUpprovedTransactions();
      return response.data.approvedTransactions;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const approveUserWithDrawal = async (
  userId: string,
  transId: string
) => {
  try {
    const response = await transactionService.approveWithdraw(userId, transId);
    return response.data;
  } catch (error: any) {
    return error?.response?.data.message;
  }
};

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllWithdrawn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllWithdrawn.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload.filter(
          (transaction: any) => transaction.transaction_type === "Withdrawal"
        );
        state.error = null;
        state.totalPrice = action.payload.reduce(
          (total: number, transaction: any) => {
            return total + (transaction.amount || 0);
          },
          0
        );
        state.totalProfit = action.payload.reduce(
          (total: number, transaction: any) => {
            return total + (transaction.userId.current_balance || 0);
          },
          0
        );
      })
      .addCase(fetchAllWithdrawn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchAllApproved.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllApproved.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload;
        state.error = null;
        state.totalPrice = action.payload.reduce(
          (total: number, transaction: any) => {
            return total + (transaction.amount || 0);
          },
          0
        );
        state.totalProfit = action.payload.reduce(
          (total: number, transaction: any) => {
            return total + (transaction.userId.current_balance || 0);
          },
          0
        );
      })
      .addCase(fetchAllApproved.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchAllWithDrawReqwuests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllWithDrawReqwuests.fulfilled, (state, action) => {
        state.loading = false;
        state.withdrawalRequests = action.payload;
        state.error = null;
      })
      .addCase(fetchAllWithDrawReqwuests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchUserTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchUserTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.userTransaction = action.payload;
        state.error = null;
      })
      .addCase(fetchUserTransactions.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserWithdrawnTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.userApprovedTransation = [];
      })
      .addCase(fetchUserWithdrawnTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.userApprovedTransation = action.payload;
        state.error = null;
      })
      .addCase(fetchUserWithdrawnTransactions.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      });

    // .addCase(approveWithdraw.pending, (state) => {
    //   state.loading = true;
    //   state.error = null;
    // })
    // .addCase(approveWithdraw.fulfilled, (state) => {
    //   state.loading = false;
    //   state.error = null;
    // })
    // .addCase(approveWithdraw.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload as string;
    // })z
    // .addCase(deleteWithdraw.pending, (state) => {
    //   state.loading = true;
    //   state.error = null;
    // })
    // .addCase(deleteWithdraw.fulfilled, (state) => {
    //   state.loading = false;
    //   state.error = null;
    // })
    // .addCase(deleteWithdraw.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload as string;
    // });
  },
});

export const selectAllWithdrawRequests = (state: any) =>
  state.transaction.withdrawalRequests;
export const selectWithdrawnLoading = (state: any) => state.transaction.loading;
export const selectWithdrawnError = (state: any) => state.transaction.error;
export const selectTotalPrice = (state: any) => state.transaction.totalPrice;
export const selectTotalProfit = (state: any) => state.transaction.totalProfit;
export const selectUserTransaction = (state: any) =>
  state.transaction.userTransaction;
export const selectUserApprovedTransaction = (state: any) =>
  state.transaction.userApprovedTransation;

export default transactionSlice.reducer;
